
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $55ad60464bc86197$exports = {};

$parcel$export($55ad60464bc86197$exports, "is-open", function () { return $55ad60464bc86197$export$a9781837241c946d; }, function (v) { return $55ad60464bc86197$export$a9781837241c946d = v; });
$parcel$export($55ad60464bc86197$exports, "spectrum-ColorLoupe", function () { return $55ad60464bc86197$export$88d6ed2576b21809; }, function (v) { return $55ad60464bc86197$export$88d6ed2576b21809 = v; });
$parcel$export($55ad60464bc86197$exports, "spectrum-ColorLoupe-inner-background", function () { return $55ad60464bc86197$export$397af82b48750fe5; }, function (v) { return $55ad60464bc86197$export$397af82b48750fe5 = v; });
$parcel$export($55ad60464bc86197$exports, "spectrum-ColorLoupe-inner-checker", function () { return $55ad60464bc86197$export$f9a2a02e0b271024; }, function (v) { return $55ad60464bc86197$export$f9a2a02e0b271024 = v; });
$parcel$export($55ad60464bc86197$exports, "spectrum-ColorLoupe-outer", function () { return $55ad60464bc86197$export$d6ad38291e8aca9c; }, function (v) { return $55ad60464bc86197$export$d6ad38291e8aca9c = v; });
var $55ad60464bc86197$export$a9781837241c946d;
var $55ad60464bc86197$export$88d6ed2576b21809;
var $55ad60464bc86197$export$397af82b48750fe5;
var $55ad60464bc86197$export$f9a2a02e0b271024;
var $55ad60464bc86197$export$d6ad38291e8aca9c;
$55ad60464bc86197$export$a9781837241c946d = `sSiP7G_is-open`;
$55ad60464bc86197$export$88d6ed2576b21809 = `sSiP7G_spectrum-ColorLoupe`;
$55ad60464bc86197$export$397af82b48750fe5 = `sSiP7G_spectrum-ColorLoupe-inner-background`;
$55ad60464bc86197$export$f9a2a02e0b271024 = `sSiP7G_spectrum-ColorLoupe-inner-checker`;
$55ad60464bc86197$export$d6ad38291e8aca9c = `sSiP7G_spectrum-ColorLoupe-outer`;


export {$55ad60464bc86197$exports as default};
//# sourceMappingURL=colorloupe_vars_css.mjs.map
